import { i18n } from 'i18n';
import IdField from 'modules/shared/fields/idField';
import DateTimeField from 'modules/shared/fields/dateTimeField';
import DateTimeRangeField from 'modules/shared/fields/dateTimeRangeField';
import StringField from 'modules/shared/fields/stringField';
import BooleanField from 'modules/shared/fields/booleanField';
import RelationToOneField from 'modules/shared/fields/relationToOneField';
import ImagesField from 'modules/shared/fields/imagesField';

function label(name) {
  return i18n(`entities.customer.fields.${name}`);
}

const fields = {
  id: new IdField('id', label('id')),
  name: new StringField('name', label('name'), {
    "required": true,
    "min": 2,
    "max": 255
  }),
  cellphone: new StringField('cellphone', label('cellphone'), {}),
  email: new StringField('email', label('email'), {}),
  company: new RelationToOneField('company', label('company'), {}),
  buildingLevel2: new RelationToOneField('buildingLevel2', label('buildingLevel2'), {}),
  photo: new ImagesField('photo', label('photo'), 'customer/photo',{}),
  pcd: new BooleanField('pcd', label('pcd')),
  enable: new BooleanField('enable', label('enable')),
  documentNumber: new StringField('documentNumber', label('documentNumber'), {}),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),

};

export default {
  fields,
};
